module.exports = __webpack_public_path__ + "img/hiq-white.2f3615d3.svg";